var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon=facebook"},React.createElement("path",{"id":"Vector","d":"M21 12C21 7.02943 16.9706 3 12 3C7.02943 3 3 7.02943 3 12C3 16.4922 6.29117 20.2155 10.5938 20.8907V14.6016H8.3086V12H10.5938V10.0172C10.5938 7.76156 11.9374 6.51563 13.9932 6.51563C14.9779 6.51563 16.0078 6.69141 16.0078 6.69141V8.90625H14.8729C13.7549 8.90625 13.4063 9.60001 13.4063 10.3118V12H15.9024L15.5033 14.6016H13.4062V20.8907C17.7088 20.2155 21 16.4922 21 12Z","fill":"#303846"})));
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
